import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import styled from 'styled-components';

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Home } from './home';
import { About } from './about';
import { First100Days } from './first100days';
import { Care } from './care';
import { Profile } from './profile';
import { Prognosis } from './prognosis';

import { NoMatch } from './NoMatch';
import Sidebar from './components/Sidebar.js';
import { Footer } from './components/Footer.js';
import { editProfile } from './editProfile';
import { Burger } from './components/Burger.js';
import  {Menu} from './components/Menu.js';

import {useState, useRef } from 'react'; 
import { useOnClickOutside } from './components/hooks';

// import { inject, observer } from 'mobx-react';
// import { observe } from 'mobx';

// @inject('routerStore')
// @observer
// class PageReload extends React.Component{
//     listener = null;
//     componentDidMount() {
//       this.listener = observe(this.props.routerStore, 'location', ({ oldValue, newValue }) => {
//         if (!oldValue || oldValue.pathname !== newValue.pathname) {
//           // your logic
//         }
//       }, true)
//     }
  
//     componentWillUnmount() {
//       this.listener();
//     }
// }



function App() {

    // componentDidUpdate(){

        window.onpopstate  = (e) => {
            window.location.reload();
        // }
    }

    const [open, setOpen] = useState(false); 
    const node = useRef(); 
    useOnClickOutside(node, () => setOpen(false));
    
  return (
    <React.Fragment>
      <Router>
        <div ref={node}>
            <Burger open={open} setOpen={setOpen}></Burger>
            <Menu open={open} setOpen={setOpen}></Menu>
        </div>
        <Sidebar />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/first100days" component={First100Days} />
          <Route path="/prognosis" component={Prognosis} />
          <Route path="/care" component={Care} />
          <Route path="/profile" component={Profile} />
          <Route path="/editProfile" component={editProfile} />

          <Route component={NoMatch} />
        </Switch>
        <Footer />
      </Router>
    </React.Fragment>
  );
}

export default App;
